<template>
  <canvas v-if="videoPlayer" ref="overlayCanvas"></canvas>
</template>

<script>
export default {
  props: {
    videoPlayer: {
      type: HTMLVideoElement,
      required: true,
    },
    currentFrame: {
      type: Number,
      required: true,
    },
    predictions: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      defaultVideoDimensions: { width: 640, height: 480 },
      animationFrameId: null,
      colors: [
        'red',
        'green',
        'blue',
        'yellow',
        'purple',
        'orange',
        'pink',
        'brown',
        'black',
      ],
    };
  },
  mounted() {
    this.setupCanvas();
    window.addEventListener('resize', this.setupCanvas);
  },

  beforeUnmount() {
    window.removeEventListener('resize', this.setupCanvas);
    // this.stopRendering();
  },
  methods: {
    setupCanvas() {
      if (!this.videoPlayer) return;

      const { width, height } = this.videoPlayer.getBoundingClientRect();
      const canvas = this.$refs.overlayCanvas;
      const { width: defaultWidth, height: defaultHeight } =
        this.defaultVideoDimensions;
      if (width / height < defaultWidth / defaultHeight) {
        canvas.width = width;
        canvas.height = (width * defaultHeight) / defaultWidth;
        canvas.style.top = (height - canvas.height) / 2 + 'px';
        canvas.style.left = 0;
      } else {
        canvas.width = (height * defaultWidth) / defaultHeight;
        canvas.height = height;
        canvas.style.left = (width - canvas.width) / 2 + 'px';
        canvas.style.top = 0;
      }
      canvas.style.position = 'absolute';
      canvas.style.pointerEvents = 'none';

      this.drawBoundingBoxes();
    },

    drawBoundingBoxes(currentFrame = this.currentFrame) {
      const { width: defaultWidth, height: defaultHeight } =
        this.defaultVideoDimensions;
      const canvas = this.$refs.overlayCanvas;
      const ctx = canvas.getContext('2d');

      ctx.clearRect(0, 0, canvas.width, canvas.height);

      const boundingBoxes =
        (this.predictions && this.predictions[currentFrame]?.bboxes) || [];

      if (!boundingBoxes) return;

      ctx.lineWidth = 2;
      ctx.font = '14px Arial';
      ctx.fillStyle = 'yellow';
      ctx.textAlign = 'left';
      ctx.textBaseline = 'top';

      boundingBoxes.forEach((box, index) => {
        ctx.strokeStyle = this.colors[index % this.colors.length];
        let [x1, y1, x2, y2, object_name] = box;
        x1 *= canvas.width / defaultWidth;
        y1 *= canvas.height / defaultHeight;
        x2 *= canvas.width / defaultWidth;
        y2 *= canvas.height / defaultHeight;
        const x = x1;
        const y = y1;
        const width = x2 - x1;
        const height = y2 - y1;
        ctx.strokeRect(x, y, width, height);

        const label = object_name || `Object ${index + 1}`;
        this.drawLabel(ctx, x, y, width, height, label);
      });
    },
    drawLabel(ctx, x, y, width, height, label) {
      const padding = 4;
      const textWidth = ctx.measureText(label).width;
      const textHeight = 16; // Approximate text height
      let labelX, labelY;

      // **Smart Label Positioning**
      if (y - textHeight - padding > 0) {
        labelX = x;
        labelY = y - textHeight - padding;
      } else if (x + width + textWidth + padding < ctx.canvas.width) {
        labelX = x + width + padding;
        labelY = y;
      } else if (y + height + textHeight + padding < ctx.canvas.height) {
        labelX = x + width + padding;
        labelY = y + height - textHeight;
      } else {
        labelX = x;
        labelY = y + height + padding;
      }

      // Draw label background
      ctx.fillStyle = 'rgba(0, 0, 0, 0.6)';
      ctx.fillRect(labelX, labelY, textWidth + padding * 2, textHeight);

      // Draw label text
      ctx.fillStyle = 'white';
      ctx.fillText(label, labelX + padding, labelY + padding);
    },
  },
};
</script>

<style scoped>
.video-container {
  position: relative;
  display: inline-block;
}
video {
  display: block;
}
canvas {
  position: absolute;
  top: 0;
  left: 0;
}
</style>
